import { IAuthContext, shouldMaskSensitiveData } from '@luzula/luzula-lib';

/**
 * Personenangaben an einem Punkt — was ein Datennutzer (Gastmodus) und ein
 * nicht Angemeldeter NICHT sehen darf: Kartierer, Aufnahmedatum, „zuletzt
 * bearbeitet von", der Importeur. In der Oberflaeche uebernimmt das die Pipe
 * `maskForGuest` (Lib); hier steht dieselbe Regel fuer alles, was nicht durch
 * eine Vorlage laeuft: Export, PDF-Druck, Suche.
 *
 * Nutzer-Befund 06.09.2026: Im Reiter „Hinweise" und im PDF-Druck standen die
 * Klarnamen und Zeitpunkte trotz Gastmodus weiter da.
 */

/** Der Ausschnitt des Anmelde-Dienstes, den die Regel braucht. */
export type PersonenSicht = Pick<IAuthContext, 'isGuest' | 'isDatennutzer' | 'isAuthenticated'>;

/** Platzhalter, der an die Stelle eines verborgenen Wertes tritt (wie in der Pipe). */
export const PERSONENANGABE_VERBORGEN = '–';

/** Darf der aktuelle Nutzer Personenangaben NICHT sehen? (Datennutzer oder nicht angemeldet) */
export function personenangabenVerbergen(aus: PersonenSicht): boolean {
	return shouldMaskSensitiveData(aus as IAuthContext);
}

/**
 * Tiefe Kopie eines Punkts ohne Personenangaben — fuer Export und Druck.
 * Das Original bleibt unberuehrt (es koennte noch gespeichert werden).
 *
 * Entfernt: Kartierer (Platzhalter), Aufnahmedatum (leer), „zuletzt
 * bearbeitet" ganz, der Importeur. Kommentare und Workflow-Verlauf bleiben
 * im Datensatz — die Ausgaben, die diese Funktion nutzen (GIS-Export,
 * PDF-Protokoll), drucken sie nicht; in der Oberflaeche verbergen die
 * Lib-Bauteile sie selbst.
 */
export function ohnePersonenangaben<T>(doc: T): T {
	const kopie: any = JSON.parse(JSON.stringify(doc));
	if (kopie?.header?.aufnahme) {
		kopie.header.aufnahme.kartierer = PERSONENANGABE_VERBORGEN;
		kopie.header.aufnahme.datum = null;
	}
	if (kopie?.lastModified) delete kopie.lastModified;
	if (kopie?.importInfo?.user) delete kopie.importInfo.user;
	return kopie as T;
}
